import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const PROJECT_IDENTIFIER = 'CHAT_WEB';

if (typeof window !== 'undefined') {
  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || '',
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ['production', 'staging', 'development'],
    onError: event => {
      console.error('Bugsnag error:', event);
    },
    autoDetectErrors: true,
    autoTrackSessions: true,
    enabledBreadcrumbTypes: ['navigation', 'request', 'state', 'user', 'error'],
    maxBreadcrumbs: 25,
    endpoints: {
      notify: 'https://notify.bugsnag.com',
      sessions: 'https://sessions.bugsnag.com'
    }
  });

  console.log('Bugsnag initialized');
}

export const notifyError = (
  error: Error,
  context?: Record<string, unknown>
) => {
  if (typeof window !== 'undefined') {
    const projectError = new Error(`${PROJECT_IDENTIFIER}: ${error.message}`);
    projectError.stack = error.stack;
    projectError.name = `${PROJECT_IDENTIFIER}_${error.name}`;

    Bugsnag.leaveBreadcrumb('GraphQL Error', {
      message: error.message,
      name: error.name,
      timestamp: new Date().toISOString()
    });

    Bugsnag.notify(projectError, event => {
      if (context) {
        event.addMetadata('context', {
          ...context,
          project: PROJECT_IDENTIFIER,
          originalError: {
            name: error.name,
            message: error.message,
            stack: error.stack
          }
        });
      }
    });
  } else {
    console.error('Server-side error:', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      context
    });
  }
};

export default Bugsnag;
